export default function(_el) {

  const mobileOpen = _el.parentNode.querySelector('.events-filter__mobile-open');
  const mobileClose = _el.querySelector('.events-filter__mobile-close');

  mobileOpen.addEventListener('click', e => {
    e.preventDefault();
    document.documentElement.classList.add('show-events-filter');
  });

  mobileClose.addEventListener('click', e => {
    e.preventDefault();
    document.documentElement.classList.remove('show-events-filter');
  });

}